import EnumDataSource from "../utils/enum-data-source.util";

export const APPOINTMENT_STATUS_DRAFT = 0;
export const APPOINTMENT_STATUS_UNCONFIRMED = 1;
export const APPOINTMENT_STATUS_CONFIRMED = 2;
export const APPOINTMENT_STATUS_CANCELED = 3;
export const APPOINTMENT_STATUS_NO_SHOW = 4;
export const APPOINTMENT_STATUS_ARRIVED = 5;
export const APPOINTMENT_STATUS_READY = 6;
export const APPOINTMENT_STATUS_RESCHEDULED = 7;
export const APPOINTMENT_STATUS_COMPLETED = 99;

export const VISIBLE_STATUSES_CODES = [
  APPOINTMENT_STATUS_DRAFT,
  APPOINTMENT_STATUS_UNCONFIRMED,
  APPOINTMENT_STATUS_CONFIRMED,
  APPOINTMENT_STATUS_NO_SHOW,
  APPOINTMENT_STATUS_ARRIVED,
  APPOINTMENT_STATUS_COMPLETED
];

export const NON_FINAL_STATUSES_CODES = [
  APPOINTMENT_STATUS_DRAFT,
  APPOINTMENT_STATUS_UNCONFIRMED,
  APPOINTMENT_STATUS_CONFIRMED,
  APPOINTMENT_STATUS_ARRIVED
];

const status = {
  [APPOINTMENT_STATUS_DRAFT]: "Draft",
  [APPOINTMENT_STATUS_UNCONFIRMED]: "Unconfirmed",
  [APPOINTMENT_STATUS_CONFIRMED]: "Confirmed",
  [APPOINTMENT_STATUS_CANCELED]: "Canceled",
  [APPOINTMENT_STATUS_NO_SHOW]: "No-Show",
  [APPOINTMENT_STATUS_ARRIVED]: "Arrived",
  [APPOINTMENT_STATUS_READY]: "Ready",
  [APPOINTMENT_STATUS_RESCHEDULED]: "Rescheduled",
  [APPOINTMENT_STATUS_COMPLETED]: "Completed"
};

export const APPOINTMENT_STATUSES = new EnumDataSource(status);

const physicianReferral = {
  "1": "Not Required",
  "2": "Required - Requested",
  "3": "Required - Received",
  "4": "Need to Request",
  "5": "Patient Bringing"
};

// Deliberately not numeric-code order. Codes 4 and 5 were appended to the backend enum
// (scheduling.PhysicianReferralType) because codes are append-only, but they belong
// mid-list so the picker reads as the referral lifecycle: nothing owed -> the clinic owes
// a request -> waiting on the physician -> waiting on the patient -> in hand. Without this
// map EnumDataSource sorts by code and both new options fall to the bottom of the list.
const physicianReferralOrder = {
  "1": 1, // Not Required
  "4": 2, // Need to Request
  "2": 3, // Required - Requested
  "5": 4, // Patient Bringing
  "3": 5 // Required - Received
};

export const PHYSICIAN_REFERRAL = new EnumDataSource(
  physicianReferral,
  physicianReferralOrder
);

export const QUICK_FILTER_DEFAULT_TYPE: string = "1";
export const QUICK_FILTER_UNCONFIRMED_APPOINTMENTS_TYPE: string = "2";
export const QUICK_FILTER_OPPORTUNITY_TYPE: string = "3";
export const QUICK_FILTER_INCOMPLETE_TYPE: string = "4";
export const QUICK_FILTER_DRAFT_APPOINTMENTS: string = "5";
export const QUICK_FILTER_CANCELED_APPOINTMENTS: string = "6";

const schedulingQuickFiltersType = {
  [QUICK_FILTER_DEFAULT_TYPE]: "All Appointments",
  [QUICK_FILTER_UNCONFIRMED_APPOINTMENTS_TYPE]: "Unconfirmed Appointments",
  [QUICK_FILTER_OPPORTUNITY_TYPE]: "Opportunity Appointments",
  [QUICK_FILTER_INCOMPLETE_TYPE]: "Incomplete Appointments",
  [QUICK_FILTER_DRAFT_APPOINTMENTS]: "Web Scheduler Appointments",
  [QUICK_FILTER_CANCELED_APPOINTMENTS]: "Canceled/Rescheduled Appointments"
};

export const QUICK_FILTER_TYPES = new EnumDataSource(
  schedulingQuickFiltersType
);

export const EVENT_TYPE_APPOINTMENT: string = "Appointment";
export const EVENT_TYPE_PERSONAL_EVENT: string = "Personal";
export const EVENT_TYPE_APPOINTMENT_BLOCK: string = "Block";
export const EVENT_TYPE_CLINIC_EVENT: string = "Clinic";
export const EVENT_TYPE_PERSONAL_WORKSHIFT: string = "WorkShift";
export const EVENT_TYPE_SCHEDULE_CODE = "S";
export const EVENT_TYPE_WORK_SHIFT_CODE = "W";
export const EVENT_TYPE_APPOINTMENT_CODE = "A";

const eventTypes = {
  [EVENT_TYPE_APPOINTMENT]: "Appointment",
  [EVENT_TYPE_PERSONAL_EVENT]: "Personal Event",
  [EVENT_TYPE_APPOINTMENT_BLOCK]: "Dedicated Appointment Slot",
  [EVENT_TYPE_CLINIC_EVENT]: "Clinic Event",
  [EVENT_TYPE_PERSONAL_WORKSHIFT]: "Work Shift"
};

export const EVENT_TYPES = new EnumDataSource(eventTypes);
export const REOCCURRENCE_PERIOD_TYPE_WEEKLY = "W";
export const REOCCURRENCE_PERIOD_TYPE_MONTHLY = "M";
export const REOCCURRENCE_PERIOD_TYPE_DAILY = "D";
export const REOCCURRENCE_PERIOD_TYPE_DAY_IN_WEEK_OF_MONTH = "DWM";

const recurrencePeriods = {
  [REOCCURRENCE_PERIOD_TYPE_DAILY]: "Daily",
  [REOCCURRENCE_PERIOD_TYPE_WEEKLY]: "Every week",
  [REOCCURRENCE_PERIOD_TYPE_MONTHLY]: "Every month",
  [REOCCURRENCE_PERIOD_TYPE_DAY_IN_WEEK_OF_MONTH]:
    "Every nth weekday of the month"
};

export const REOCCURRENCE_PERIODS = new EnumDataSource(recurrencePeriods);

const recurrenceDays = {
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
  7: "Sunday"
};

export const RECURRENCE_DAYS = new EnumDataSource(recurrenceDays);

export const RECURRENCE_WEEKS = new EnumDataSource({
  1: "Every first week of the month",
  2: "Every second week of the month",
  3: "Every third week of the month",
  4: "Every fourth week of the month",
  5: "Every last week of the month"
});

export const WORK_WEEK_EXCLUDED_DAYS = [0, 6];
export const APPOINTMENTS_LIST_KEY_DEFAULT = "appointmentsList";

export const NOTIFICATION_METHOD_SMS = 1;
export const NOTIFICATION_METHOD_EMAIL = 2;

const notificationMethods = {
  [NOTIFICATION_METHOD_SMS]: "SMS",
  [NOTIFICATION_METHOD_EMAIL]: "Email"
};

export const NOTIFICATION_METHODS = new EnumDataSource(notificationMethods);

export const SUNO_SOURCE_UUID = "2692a07e-8304-4e13-b462-bd9429c67e6a";
export const WEB_SCHEDULER_SOURCE_UUID = "3e14b695-18e4-48bb-a5aa-e315109c3ef8";
export const GOOGLE_CALENDAR_SOURCE_UUID = "c7f8a2d1-5e3b-4a9c-8f6d-2b1e0c4a7d3f";
